let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");

let main = function () {
    return Backbone.View.extend({
        events: {
            "click .payment-list .payment": "_clickPayment",
            "click .footer a": "_toRestaurantSetting"

        },

        _clickPayment: function (evt) {
            var self = this, target = $(evt.currentTarget), name = target.attr("data-name"),
                mode = $('.mode[data-mode=' + name + ']');
            $('.mode').removeClass('selected');
            if (mode.hasClass('hidden')) {
                $('.mode:not(.hidden)').eq(2).addClass('hidden');
                mode.removeClass('hidden').addClass('selected');
            } else {
                mode.addClass('selected')
            }
            var left = mode.data("mode") == "MEMBER_CARD" ? 0: this.options.leftPay;
            this.options.numberpad.changeTarget(mode, null, left);
            self.model.set({closePayment: true, chooseMode: mode});
        },

        _toRestaurantSetting: function () {
            window.location.href = "#settings/payment";
            this.model.set({closePayment: true});
        }
    });
};

let exportedValue = main();

module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/view/cashier/PaymentSelectorView.js